export const RECEIVE_RETURN_DETAILS = "RECEIVE_RETURN_DETAILS";
export const REQUEST_RETURN_DETAILS = "REQUEST_RETURN_DETAILS";
